var _circle, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 31,
    fill: "#80CB7C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 47L16.4512 38.3036C14.8749 35.6286 14.045 32.5851 14.045 29.4586C14.045 19.8319 21.8854 12 31.5226 12C41.1597 12 49 19.8319 49 29.4586C49 39.0853 41.1597 46.9172 31.5226 46.9172C28.5197 46.9172 25.5793 46.1494 22.9781 44.6914L14 47ZM23.4371 41.5152L23.9721 41.8415C26.24 43.2246 28.851 43.9556 31.5226 43.9556C39.5249 43.9556 46.0352 37.4523 46.0352 29.4586C46.0352 21.4649 39.5249 14.9616 31.5226 14.9616C23.5202 14.9616 17.0098 21.4649 17.0098 29.4586C17.0098 32.2439 17.8023 34.9487 19.3013 37.2805L19.6616 37.8409L18.2501 42.849L23.4371 41.5152Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6217 20.8133L25.5035 20.752C25.1523 20.7328 24.8078 20.8507 24.5423 21.0823C24.0003 21.5551 23.1335 22.4692 22.8673 23.6604C22.4702 25.4365 23.0838 27.6114 24.6717 29.7863C26.2597 31.9612 29.2189 35.4411 34.4517 36.9273C36.1379 37.4062 37.4644 37.0833 38.4879 36.4258C39.2984 35.905 39.8572 35.0691 40.0586 34.1241L40.2371 33.2865C40.2938 33.0203 40.1593 32.7502 39.9131 32.6362L36.134 30.8866C35.8887 30.7731 35.5978 30.8449 35.4328 31.0596L33.9492 32.9914C33.8372 33.1373 33.6453 33.1952 33.4721 33.1341C32.4561 32.7754 29.0529 31.3438 27.1855 27.7308C27.1046 27.5741 27.1247 27.3839 27.2396 27.2503L28.6574 25.6028C28.8023 25.4346 28.8389 25.1981 28.7518 24.9936L27.1229 21.1657C27.0361 20.9619 26.8418 20.8253 26.6217 20.8133Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.c683413b6a5e4322f9b32cb8304e182e.svg";
export { ForwardRef as ReactComponent };